<template>
  <div class="wrapper">
    <div class="wrapper-overlay"></div>
    <e-tema-toggle icon-color="white" btn-class="auth-tema-toggle" />
    <v-card elevation="0" class="login-card">
      <div class="auth-accent-bar"></div>
      <div class="auth-orb"></div>
      <v-card-text class="pa-8">
        <div class="d-flex flex-column align-center mb-6 fade-up">
          <div class="auth-logo-badge mb-4 d-flex align-center justify-center">
            <img src="/img/logo-pontofiq-recorte.png" alt="Logo" />
          </div>
          <h1 class="auth-title">Bem-vindo(a) de volta!</h1>
          <p class="auth-subtitle">Informe suas credenciais para acessar o painel de ponto.</p>
        </div>

        <ValidationObserver v-slot="{ handleSubmit }">
          <v-form ref="form" @submit.prevent="handleSubmit(logar)" class="fade-up d2">
            <ValidationProvider name="Login de acesso" rules="required" v-slot="{ errors }">
              <v-text-field
                id="input-email"
                v-model="credentials.email"
                filled
                rounded
                dense
                background-color="var(--input-bg)"
                color="var(--brand)"
                prepend-inner-icon="mdi-account-outline"
                label="Login de acesso"
                :error-messages="errors"
                required
              />
            </ValidationProvider>
            <ValidationProvider name="Senha" rules="required" v-slot="{ errors }">
              <v-text-field
                id="input-password"
                v-model="credentials.password"
                filled
                rounded
                dense
                background-color="var(--input-bg)"
                color="var(--brand)"
                prepend-inner-icon="mdi-lock-outline"
                label="Senha"
                :type="showPassword ? 'text' : 'password'"
                :error-messages="errors"
                required
              >
                <template #append>
                  <v-icon
                    id="btn-toggle-password-visibility"
                    color="#9f86d6"
                    @click="showPassword = !showPassword"
                  >
                    {{ showPassword ? "mdi-eye" : "mdi-eye-off" }}
                  </v-icon>
                </template>
              </v-text-field>
            </ValidationProvider>
            <v-btn
              id="btn-login"
              block
              type="submit"
              class="auth-btn mt-4"
              :class="loginButtonClass"
              :disabled="logando"
              :loading="logando"
            >
              Entrar no sistema
            </v-btn>
          </v-form>
        </ValidationObserver>

        <div class="d-flex align-center auth-divider fade-up d3">
          <span class="auth-divider-line"></span>
          <span class="auth-divider-text">ou</span>
          <span class="auth-divider-line"></span>
        </div>

        <div class="d-flex justify-center fade-up d3">
          <a
            id="link-reset-password"
            @click="$router.push({ name: 'resetPassword' })"
            target="__blank"
            class="auth-help-link"
            :class="{ 'animate__animated animate__headShake': animarAjuda }"
          >
            <v-icon small left>mdi-lock-question-outline</v-icon>
            Esqueci minha senha!
          </a>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "LoginPage",
  data() {
    return {
      credentials: { email: "", password: "" },
      showPassword: false,
      logando: false,
      loginButtonClass: "",
      animarAjuda: false,
    };
  },
  mounted() {
    const switchAnimarAjuda = () => {
      this.animarAjuda = !this.animarAjuda;
      setTimeout(() => switchAnimarAjuda(), 2000);
    };
    switchAnimarAjuda();
  },
  methods: {
    async logar() {
      this.logando = true;
      try {
        await this.$services.authService.logar(this.credentials);
        this.$toast.success("Logado no sistema com sucesso!");
        const user = await this.$services.authService.getCurrentUser();
        const { name, redirect } = this.$route.query;
        let has_permission = false;
        user.permissions.forEach((e) => {
          if (name === e || `${name}.*` === e || `${name?.split(".")[0]}.atualizar` === e) {
            has_permission = true;
          }
        });
        if (redirect && has_permission) this.$router.push(redirect);
        else this.$router.push({ name: "home" });
      } catch (error) {
        this.loginButtonClass = "animate__animated animate__headShake";
        const message =
          error?.response?.data?.error?.message || error.message || "Erro ao fazer login";
        this.$toast.danger(message);
        setTimeout(() => (this.loginButtonClass = ""), 500);
      } finally {
        this.logando = false;
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: 100vh;
  width: 100vw;
  position: absolute;
  background-image: url("../../assets/background-2.png");
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 16px;
}

.wrapper-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    160deg,
    rgba(79, 0, 143, 0.58) 0%,
    rgba(124, 58, 237, 0.42) 55%,
    rgba(167, 139, 250, 0.28) 100%
  );
}

.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 440px;
  background: var(--surface) !important;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 20px;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.35);
  overflow: hidden;
  animation: fadeUp 0.55s ease both;
}

.auth-accent-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4f008f 0%, #7c3aed 100%);
}

.auth-orb {
  position: absolute;
  top: -70px;
  right: -50px;
  width: 220px;
  height: 200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(124, 58, 237, 0.12), transparent 70%);
  pointer-events: none;
}

.auth-logo-badge {
  padding: 10px 28px;
  border-radius: 16px;
  background: linear-gradient(135deg, #f5f0ff, #ffffff);
  border: 1px solid #e6d9fb;
  box-shadow: 0 10px 24px rgba(79, 0, 143, 0.16);
}

.auth-logo-badge img {
  display: block;
  height: 80px;
  width: auto;
  object-fit: contain;
}

.auth-title {
  font-size: 24px;
  font-weight: 800;
  margin: 0;
  background: linear-gradient(90deg, var(--brand), var(--brand-3));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-align: center;
}

.auth-subtitle {
  font-size: 13.5px;
  color: var(--text-muted);
  text-align: center;
  margin-top: 6px;
  font-weight: 500;
}

.auth-btn {
  height: 48px !important;
  border-radius: 12px !important;
  text-transform: none;
  font-weight: 800;
  letter-spacing: 0.5px;
  font-size: 15px;
  color: #ffffff !important;
  background: linear-gradient(90deg, #4f008f 0%, #7c3aed 100%) !important;
  box-shadow: 0 10px 22px rgba(79, 0, 143, 0.35);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.auth-btn:not(.v-btn--disabled):hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 30px rgba(79, 0, 143, 0.4);
}

.auth-divider {
  gap: 14px;
  margin: 22px 0 16px;
}

.auth-divider-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--brand-border), transparent);
}

.auth-divider-text {
  font-size: 12px;
  font-weight: 700;
  color: var(--text-faint);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.auth-help-link {
  text-decoration: none;
  color: var(--brand);
  font-weight: 600;
  font-size: 13.5px;
  padding: 9px 18px;
  border-radius: 999px;
  background: var(--input-bg);
  border: 1px solid var(--brand-border);
  transition: all 0.18s ease;
}

a.auth-help-link:hover {
  background: var(--brand-soft-2);
  border-color: #d0bbf3;
}

.fade-up {
  animation: fadeUp 0.5s ease both;
}

.d2 {
  animation-delay: 0.1s;
}

.d3 {
  animation-delay: 0.18s;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .fade-up,
  .login-card {
    animation: none;
  }
}
</style>
